import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { LiBreadcrumb } from "../components/LiBreadcrumb";
import { LiExplainer } from "../components/LiExplainer";
import { LoremGenerator } from "../components/LoremGenerator";

export function LoremIpsumPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <LiBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.li_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.li_intro()}
          </p>
        </header>

        <LoremGenerator />

        <LiExplainer
          howTo={m.li_howto()}
          faqs={[
            { q: m.li_faq1_q(), a: m.li_faq1_a() },
            { q: m.li_faq2_q(), a: m.li_faq2_a() },
            { q: m.li_faq3_q(), a: m.li_faq3_a() },
            { q: m.li_faq4_q(), a: m.li_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
